import Extend from 'flarum/common/extenders';
import StatisticsPage from './components/StatisticsPage';
export default [new Extend.Admin().page(StatisticsPage)];